module.exports = __webpack_public_path__ + "assets/img/obstacle.fabbc261.jpg";